module.exports = __webpack_public_path__ + "img/head4.6ba0c0a0.png";